(() => {
  class IwbExperience {
    constructor(root) {
      this.root = root;
      this.range = root.querySelector('[data-reveal-range]');
      this.reveal = root.querySelector('[data-iwb-reveal]');
      this.sliderWrap = root.querySelector('[data-slider-wrap]');
      this.unlockPanel = root.querySelector('[data-unlock-panel]');
      this.completed = false;
      this.bindVideos();
      this.bindReveal();
      this.bindUnlock();
      this.bindProducts();
    }

    bindVideos() {
      const before = this.root.querySelector('[data-iwb-before-video]');
      const after = this.root.querySelector('[data-iwb-after-video]');
      if (!before || !after) return;
      const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      const pause = () => { before.pause(); after.pause(); };
      const play = async () => {
        if (motionPreference.matches || document.hidden) return pause();
        if (Number.isFinite(before.currentTime)) after.currentTime = before.currentTime;
        await Promise.allSettled([before.play(), after.play()]);
      };
      const applyPreference = () => {
        if (motionPreference.matches) {
          pause();
          before.currentTime = 0;
          after.currentTime = 0;
        } else {
          play();
        }
      };
      before.addEventListener('loadedmetadata', play, { once:true });
      after.addEventListener('loadedmetadata', play, { once:true });
      document.addEventListener('visibilitychange', play);
      motionPreference.addEventListener?.('change', applyPreference);
      window.setInterval(() => {
        if (!motionPreference.matches && !before.paused && Math.abs(before.currentTime - after.currentTime) > .12) {
          after.currentTime = before.currentTime;
        }
      }, 1000);
      applyPreference();
    }

    bindReveal() {
      if (!this.range || !this.reveal) return;
      const update = () => {
        const value = Number(this.range.value);
        this.root.style.setProperty('--reveal', `${value}%`);
        this.root.style.setProperty('--reveal-opacity', String(value / 100));
        this.range.setAttribute('aria-valuetext', `${value}% revealed`);
        if (value >= 98) this.completeReveal();
      };
      this.range.addEventListener('input', update);
      this.range.addEventListener('change', update);
      update();
    }

    completeReveal() {
      if (this.completed) return;
      this.completed = true;
      this.root.style.setProperty('--reveal', '100%');
      this.root.style.setProperty('--reveal-opacity', '1');
      this.range.value = '100';
      this.unlockPanel.hidden = false;
      window.setTimeout(() => this.unlockPanel.querySelector('input, a, button')?.focus({ preventScroll:true }), 250);
    }

    bindUnlock() {
      const form = this.root.querySelector('[data-unlock-form]');
      if (!form) return;
      const input = form.querySelector('input[type="email"]');
      const error = form.querySelector('[data-email-error]');
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        error.textContent = '';
        if (!input.checkValidity()) {
          error.textContent = 'Enter a valid email address.';
          input.focus();
          return;
        }
        const loginUrl = new URL(this.root.dataset.loginPath, window.location.origin);
        loginUrl.searchParams.set('login_hint', input.value.trim());
        loginUrl.searchParams.set('return_to', this.root.dataset.returnTo);
        window.location.assign(loginUrl.toString());
      });
    }

    bindProducts() {
      this.root.querySelectorAll('[data-product-card]').forEach((card) => {
        const sizes = [...card.querySelectorAll('[data-size-option]')];
        const addButton = card.querySelector('[data-add-to-cart]');
        const addLabel = card.querySelector('[data-add-label]');
        const price = card.querySelector('[data-card-price]');
        const status = card.querySelector('[data-card-status]');
        let selectedButton = null;

        sizes.forEach((button) => button.addEventListener('click', () => {
          sizes.forEach((item) => item.classList.remove('is-selected'));
          button.classList.add('is-selected');
          selectedButton = button;
          addButton.disabled = false;
          addLabel.textContent = 'Add to cart';
          if (button.dataset.price) price.textContent = button.dataset.price;
          status.textContent = '';
        }));

        addButton?.addEventListener('click', async () => {
          if (!selectedButton || !window.IwbCart) return;
          addButton.disabled = true;
          addLabel.textContent = 'Adding…';
          status.textContent = '';
          let added = false;
          try {
            await window.IwbCart.add({
              variantId:Number(selectedButton.dataset.variantId),
              productId:Number(addButton.dataset.productId),
            });
            added = true;
            addLabel.textContent = 'Already in cart';
            status.textContent = 'Remove this item from your cart to choose another size.';
          } catch (error) {
            addLabel.textContent = 'Add to cart';
            status.textContent = error.message || 'Could not add this size. Try again.';
          } finally {
            if (!added) addButton.disabled = false;
          }
        });

        card.addEventListener('click', (event) => {
          if (event.target.closest('a,button,fieldset')) return;
          window.location.assign(card.dataset.productUrl);
        });
        card.addEventListener('keydown', (event) => {
          if (event.key === 'Enter' && !event.target.closest('button')) window.location.assign(card.dataset.productUrl);
        });
      });
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll('[data-iwb-experience]').forEach((root) => {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';
      new IwbExperience(root);
    });
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
